export default __webpack_public_path__ + "static/media/330_business02-nl-mobile.2465e728.png";